<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme

export default {
  props: {
    data: {
      type: Array,
      default: []
    },
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '45vh'
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    data (val) {
      this.setOption(val);
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOption(this.data)
    },
    setOption(data) {
      this.chart.setOption({
        // toolbox: {
        //   feature: {
        //     dataView: {readOnly: false},
        //     restore: {},
        //     saveAsImage: {}
        //   }
        // },
        series: [
          {
            type:'funnel',
            left: '0    ',
            right: '50%',
            top: 20,
            //x2: 80,
            bottom: 10,
            width: '50%',
            // height: {totalHeight} - y - y2,
            min: 0,
            // max: 100000,
            minSize: '3%',
            // maxSize: '100%',
            sort: 'none',
            funnelAlign: 'center',
            gap: 2,
            label: {
              show: true,
              position: 'right',
              fontSize: 12,
              color: '#666666',
              formatter: '{b}{c|（{c}元）}',
              rich: {
                c: {
                  color: '#222',
                  lineHeight: 12,
                  align: 'center',
                  fontWeight: 'bold'
                },
              }
            },
            labelLine: {
              length: 200,
              lineStyle: {
                width: 1,
                type: 'solid',
              }
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 0,
            },
            emphasis: {
              label: {
                fontSize: 20
              }
            },
            color: ['#48A1FF', '#5ACB74', '#FED066', '#FF7C41', '#396AFC', '#9861E6', '#F3667C'],
            data: data
          }
        ]
      })
    }
  }
}
</script>
